(() => {
  const theme = window.ProjectOptimal;
  const panel = document.querySelector('[data-site-search]');
  const input = panel?.querySelector('[data-search-input]');
  const suggestions = panel?.querySelector('[data-search-suggestions]');
  const status = panel?.querySelector('#SearchSuggestionStatus');
  if (input && suggestions && status && theme?.routes?.predictiveSearch) {
    let timer;
    let request;
    let generation = 0;
    const cache = new Map();
    const reset = () => {
      clearTimeout(timer);
      request?.abort();
      generation += 1;
      suggestions.replaceChildren();
      suggestions.hidden = true;
      suggestions.removeAttribute('aria-busy');
    };
    const safeUrl = (value, image = false) => {
      if (typeof value !== 'string' || !value.trim()) return null;
      try {
        const url = new URL(value, location.origin);
        if (!['http:', 'https:'].includes(url.protocol)) return null;
        if (!image && url.origin !== location.origin) return null;
        return url.href;
      } catch (_) { return null; }
    };
    const render = (products, term) => {
      suggestions.replaceChildren();
      const list = document.createElement('ul');
      list.setAttribute('aria-label', 'Suggested products');
      for (const product of products) {
        const url = safeUrl(product.url);
        if (!url) continue;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = url;
        link.className = 'search-suggestion';
        const imageUrl = safeUrl(product.featured_image?.url || product.image, true);
        if (imageUrl) {
          const img = document.createElement('img');
          const resized = new URL(imageUrl);
          resized.searchParams.set('width', '120');
          img.src = resized.href;
          img.alt = '';
          img.width = 60;
          img.height = 72;
          img.loading = 'lazy';
          link.append(img);
        }
        const details = document.createElement('span');
        const title = document.createElement('strong');
        title.textContent = product.title;
        const description = document.createElement('span');
        const price = Number(product.price);
        description.textContent = Number.isFinite(price)
          ? `${Number(product.price_min) !== Number(product.price_max) ? 'From ' : ''}${new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: theme.currency }).format(price)}${product.available === false ? ' · Sold out' : ''}`
          : (product.available === false ? 'Sold out' : 'View product');
        details.append(title, description);
        link.append(details);
        item.append(link);
        list.append(item);
      }
      if (list.children.length) suggestions.append(list);
      const all = document.createElement('a');
      const searchUrl = new URL(theme.routes.search, location.origin);
      searchUrl.searchParams.set('q', term);
      searchUrl.searchParams.set('type', 'product,page');
      searchUrl.searchParams.set('options[unavailable_products]', 'last');
      all.href = searchUrl.href;
      all.className = 'search-all';
      all.textContent = `View all results for “${term}” →`;
      suggestions.append(all);
      suggestions.hidden = false;
      status.textContent = list.children.length ? `${list.children.length} product suggestions. Use Tab to explore.` : 'No product suggestions. Try another word or view all results.';
    };
    input.addEventListener('input', () => {
      reset();
      const term = input.value.trim().slice(0, 200);
      if (term.length < 2) { status.textContent = 'Enter at least two characters to see suggestions.'; return; }
      const current = generation;
      timer = setTimeout(async () => {
        suggestions.setAttribute('aria-busy', 'true');
        status.textContent = 'Searching…';
        try {
          const cached = cache.get(term);
          let products = cached && Date.now() - cached.at < 60000 ? cached.products : null;
          if (!products) {
            request = new AbortController();
            const url = new URL(`${theme.routes.predictiveSearch}.json`, location.origin);
            url.searchParams.set('q', term);
            url.searchParams.set('resources[type]', 'product');
            url.searchParams.set('resources[limit]', '5');
            url.searchParams.set('resources[options][unavailable_products]', 'last');
            const data = await window.OptimalRequests.json(url, { signal: request.signal, headers: { Accept: 'application/json' } }, { operation: 'search', timeoutMs: 8000 });
            products = Array.isArray(data.resources?.results?.products) ? data.resources.results.products.slice(0, 5) : [];
            if (cache.size >= 20) cache.delete(cache.keys().next().value);
            cache.set(term, { products, at: Date.now() });
          }
          if (current !== generation || panel.hidden) return;
          render(products, term);
        } catch (error) {
          if (error.name !== 'AbortError' && current === generation) status.textContent = 'Suggestions are unavailable. Press Search to see results.';
        } finally {
          if (current === generation) suggestions.removeAttribute('aria-busy');
        }
      }, 250);
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' && !suggestions.hidden) {
        event.preventDefault();
        suggestions.querySelector('a')?.focus();
      }
    });
    suggestions.addEventListener('keydown', (event) => {
      if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
      const links = [...suggestions.querySelectorAll('a')];
      const index = links.indexOf(document.activeElement);
      event.preventDefault();
      if (event.key === 'ArrowUp' && index <= 0) input.focus();
      else links[Math.max(0, Math.min(links.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1)))]?.focus();
    });
    new MutationObserver(() => { if (panel.hidden) reset(); }).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
  }

  // Native details keep nested menus usable before JavaScript has loaded.
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.desktop-menu .nav-branch[open]').forEach((branch) => {
      if (!branch.contains(event.target)) branch.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const branch = document.activeElement?.closest('.nav-branch[open]');
    if (branch) { branch.open = false; branch.querySelector('summary')?.focus(); }
  });
})();
